<template>
  <AppScrollbar class="error-403" style="height: 100%">
    <div class="error-info clearfix">
      <div class="error-img"></div>
      <div class="button-group">
        <el-button type="warning" size="mini" plain v-if="$route.query.redirect" @click="refreshPage">点击重试</el-button>
      </div>
      <div class="tip-msg">
        <span>本次会话可能已经失效，您可以选择<a :href="getHomePath()">重新登录</a>尝试解决此问题</span>
      </div>
    </div>
  </AppScrollbar>
</template>

<script>
import Support from '../../../mixins/support'
import AppScrollbar from '../../elements/AppScrollbar'
export default {
  mixins: [Support],
  name: 'Error403',
  components: {AppScrollbar},
  props: {
    refresh: Boolean
  },
  methods: {
    // 刷新页面
    refreshPage () {
      this.$router.replace({ path: this.$route.query.redirect })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!from.matched || from.matched.length === 0) {
        // 首次打开
        vm.refreshPage()
      }
    })
  },
  watch: {
    refresh: function (val) {
      if (val) {
        this.refreshPage()
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/color" as *;

  .error-403 {
    background-color: #fff!important;
    .error-info {
      & > .error-img {
        margin: 5% auto 0;
        max-width: 100%;
        width: 600px;
        height: 360px;
        background: url("../../../assets/error/403.jpg") center no-repeat;
        background-size: cover;
      }
      & > .button-group {
        margin: 20px auto;
        text-align: center;
        .el-button {
          padding: 5px 12px;
          border-radius: 0;
        }
      }
      & > .tip-msg {
        margin: 0 auto 50px;
        text-align: center;
        font-size: 12px;
        color: #909399;
        a {
          margin: 0 2px;
          color: $set-primary-color;
          text-decoration: none;
        }
      }
    }
  }
</style>
